export default function ($scope, $uibModalInstance, $timeout, addedToPlanner, $filter) {

    $scope.getIcs = function () {

        var icsHeader = 'BEGIN:VCALENDAR\r\nVERSION:2.0\r\nPRODID:-//UniSC//NONSGML v1.0//EN\r\nX-WR-CALNAME:USC timetable planner\r\n',
            email = 'timetable@usc.edu.au',
            icsBody = '',
            icsMsg;

        angular.forEach(addedToPlanner, function (el) {

            if (el.hasOwnProperty('class')) {

                var icsEvent,
                    dtStamp = new Date(),
                    day = el.class.meetingDay,
                    startTime = $filter('date')(el.class.meetingStartTime, "HH:MM").replace(":", ""),
                    finishTime = $filter('date')(el.class.meetingEndTime, "HH:MM").replace(":", ""),
                    startDate = el.class.meetingStartDate,
                    finishDate = el.class.meetingEndDate,
                    location = el.class.room + ' ' + el.class.location,
                    title = el.courseCode + ' ' + el.class.classDesc,
                    dtStartTime = $filter('date')(startDate, 'yyyyMMdd') + 'T' + startTime + '00',
                    dtFinishTime = $filter('date')(startDate, 'yyyyMMdd') + 'T' + finishTime + '00',
                    dtEnd = $filter('date')(finishDate, 'yyyyMMdd') + 'T' + finishTime + '00';

                icsEvent = 'BEGIN:VEVENT\r\nUID:' + email + '\r\nDTSTAMP:' + dtStamp.getFullYear() + (dtStamp.getMonth() + 1) + (dtStamp.getDate() + 1) + 'T' + dtStamp.getHours() + dtStamp.getMinutes() + '\r\n';
                icsEvent += 'DTSTART:' + dtStartTime + '\r\nDTEND:' + dtFinishTime + '\r\nLOCATION:' + location + '\r\nSUMMARY:' + title + '\r\nRRULE:FREQ=WEEKLY;UNTIL=' + dtEnd + ';BYDAY=' + day.substr(0, 2).toUpperCase() + '\r\nEND:VEVENT\r\n';

                icsBody += icsEvent;
            }
        });

        icsMsg = icsHeader + icsBody + 'END:VCALENDAR';

        if (!navigator.userAgent.match(/msie|trident/i)) {

            var downloadLink = document.createElement("a");
            downloadLink.href = 'data:text/calendar;charset=utf-8,\r\n' + escape(icsMsg);
            downloadLink.download = "Timetable planner.ics";
            //when an event is triggered programmatically which already exists in the client side, it calls $apply within $digest for the second time
            // which causing Action Already In Progress error. 
            //To avoid this we need to move the call to event outside of the digest, by using $timeout(fn, 0, false)
            //refer to https://docs.angularjs.org/error/$rootScope/inprog?p0=$apply
            $timeout(function () {
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
            }, 0, false);

        }
        else {
            var blob = new Blob([icsMsg]);
            window.navigator.msSaveOrOpenBlob(blob, 'Timetable planner.ics');
        }
    };

    $scope.close = function () {
        $uibModalInstance.dismiss('cancel');
    };

};